import { useContext } from 'react';

import { useFlags } from '@mint-lib/routing-context';

import {
  CircuitDispatchContext,
  CircuitStateContext,
  initialState,
} from './context.js';

/**
 * This hook may run even when the Provider isn’t mounted due to the
 * `newApprovalMicro` feature flag. Since hooks can’t be conditional,
 * we return a fallback (`initialState`) when the flag is off
 * to avoid crashes and excessive FF checks across the app.
 * When the flag is on, the Provider is required.
 */
export const useApprovalProcessData = () => {
  const ff = useFlags('@mint/arm', ['newApprovalMicro']);
  const context = useContext(CircuitStateContext);

  if (!ff.newApprovalMicro.enabled) {
    return initialState;
  }

  if (!context) {
    throw new Error('useApprovalProcessData must be used within Provider');
  }
  return context;
};

export const useSetApprovalProcessData = () => {
  const context = useContext(CircuitDispatchContext);

  if (!context) {
    throw new Error('useSetApprovalProcessData must be used within Provider');
  }
  return context;
};
